module.exports = __webpack_public_path__ + "img/FR11188.7b83d817.png";